import Vue from 'vue'
import VueCookies from 'vue-cookies'
import { TOKEN_COOKIE_EXPIRES } from '@/shared/lib/authCookie'
import clientApi, { CLIENT_TOKEN_COOKIE, setUnauthorizedHandler } from '@/shared/lib/clientApi'
import { getErrorMessage } from '@/shared/lib/errorMessage'

// Состояние личного кабинета живёт отдельно от операторского: у него свой
// токен, своя компания и свои страницы. Пересечения с state оператора нет
// намеренно — иначе выход из кабинета гасил бы смену оператора.
const state = {
  token: VueCookies.get(CLIENT_TOKEN_COOKIE) || '',
  profile: {},
  company: {},
  loading: false
}

const getters = {
  isClientLoggedIn: state => !!state.token,
  clientProfile: state => state.profile,
  clientCompany: state => state.company
}

const mutations = {
  client_auth (state, token) {
    state.token = token
  },
  client_profile (state, { client, company }) {
    state.profile = client || {}
    state.company = company || {}
  },
  client_logout (state) {
    state.token = ''
    state.profile = {}
    state.company = {}
  },
  client_loading (state, value) {
    state.loading = value
  }
}

const actions = {
  clientLogin ({ commit, dispatch }, credentials) {
    commit('client_loading', true)

    return clientApi.post('/api/client/authenticate', credentials).
      then((response) => {
        const token = response.data.auth_token

        Vue.prototype.$cookies.set(CLIENT_TOKEN_COOKIE, token, TOKEN_COOKIE_EXPIRES)
        commit('client_auth', token)

        return dispatch('clientProfile')
      }).
      catch((error) => {
        Vue.prototype.$cookies.remove(CLIENT_TOKEN_COOKIE)
        commit('client_logout')
        Vue.prototype.$toast.error(getErrorMessage(error))

        return Promise.reject(error)
      }).
      finally(() => commit('client_loading', false))
  },

  clientProfile ({ commit }) {
    return clientApi.get('/api/client/me').then((response) => {
      commit('client_profile', response.data)

      return response.data
    })
  },

  // notifyServer — когда выход нажали сами: сервер гасит сессию токена, и он
  // перестаёт работать сразу, а не через месяц. При вылете по 401 запрос не
  // делаем: токен уже недействителен, а ответ 401 снова привёл бы сюда.
  clientLogout ({ commit }, options = {}) {
    const finish = () => {
      Vue.prototype.$cookies.remove(CLIENT_TOKEN_COOKIE)
      commit('client_logout')
    }

    if (!options.notifyServer) {
      finish()

      return Promise.resolve()
    }

    return clientApi.post('/api/client/logout').
      catch(() => null).
      then(() => finish())
  }
}

export function registerClientAuthGuard (store, router) {
  setUnauthorizedHandler(() => {
    if (!store.getters.isClientLoggedIn) return

    store.dispatch('clientLogout').then(() => {
      if (router.currentRoute.path !== '/client/login') router.push('/client/login')
    })
  })
}

export default {
  state,
  getters,
  mutations,
  actions
}
